<template>
  <div>
    <NavBar></NavBar>
    <div style="margin-top: 2%; margin-bottom: 2%">
      <LoadingSkeleton v-if="this.toggle == 0" />
      <MemberInfo
        v-if="this.toggle == 1"
        :membership="this.membership"
        :presetMembers="this.members"
        :presetEmergencyBool="this.emergencyBool"
        :isMobile="this.isMobile"
        @proceed="toPayment"
        @back="back"
      ></MemberInfo>
      <Payment
        v-if="this.toggle == 2"
        :billingInfo="this.billingInfo"
        :isMobile="this.isMobile"
        :primaryColor="this.primaryColor"
        :secondaryColor="this.secondaryColor"
        :presetBillingInfo="this.billingInfo"
        @proceed="toOrderSummary"
        @back="back"
      ></Payment>
      <OrderSummary
        v-if="this.toggle == 3"
        :membership="this.membership"
        :isMobile="this.isMobile"
        :member="this.member"
        :paymentPeriodSelected="this.paymentPeriodSelected"
        @proceed="registerMember"
        @back="back"
      ></OrderSummary>
      <RegistrationSuccess
        v-if="this.toggle == 4"
        :membership="this.membership"
      ></RegistrationSuccess>
    </div>
    <NavFooter></NavFooter>
    <div v-if="showLoading" class="loading-overlay">
      <div class="spinner"></div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'
import NavBar from '../components/NavBar.vue'
import NavFooter from '../components/NavFooter.vue'
import LoadingSkeleton from '../components/Checkout/LoadingSkeleton.vue'
import RegistrationSuccess from '../components/Checkout/MembershipSpecific/RegistrationSuccess.vue'
import Payment from '../components/Checkout/Payment.vue'
import MemberInfo from '../components/Checkout/MembershipSpecific/MemberInfo.vue'
import OrderSummary from '../components/Checkout/MembershipSpecific/OrderSummary.vue'

export default {
  components: {
    NavBar,
    NavFooter,
    RegistrationSuccess,
    Payment,
    MemberInfo,
    OrderSummary,
    LoadingSkeleton,
  },
  data() {
    return {
      showLoading: false,
      membership: {},
      member: null,
      emergencyBool: true,
      billingInfo: {
        firstName: '',
        lastName: '',
        cardNumber: '',
        cardMonth: '',
        cardYear: '',
        cardCvv: '',
        phoneNumber: '',
        email: '',
        address: '',
        city: '',
        state: '',
        zipCode: '',
      },
      toggle: 0,
      paymentPeriodSelected: '',
    }
  },
  methods: {
    back() {
      if (this.toggle == 2) {
        this.toggle = 1
        return
      }
      if (this.toggle == 3) {
        this.toggle = 2
        return
      }
      if (this.toggle == 4) {
        this.toggle = 3
      }
    },
    async getMembershipInfo() {
      let url =
        import.meta.env.VITE_APP_DB_URL +
        'membership/getMembershipForShop?userId=' +
        this.$route.params.coachId +
        '&membershipId=' +
        this.$route.params.id
      try {
        const response = await axios.get(url, {})
        this.membership = response.data.membership
        this.paymentPeriodSelected = this.$route.params.paymentPeriod
        this.toggle = 1
      } catch (error) {
        console.error('Error fetching membership:', error)
        swal(
          'Error',
          error.response?.data?.errorMessage || 'Failed to load membership',
          'error',
        )
        // You might want to redirect or handle the error in some way
      }
    },
    toPayment(member, emergencyBool) {
      this.member = member
      this.emergencyBool = emergencyBool
      this.toggle = 2
    },
    toOrderSummary(x) {
      this.billingInfo = x
      //Format the camper objects to be sent to the server
      this.member.email = this.billingInfo.email
      this.member.phoneNumber = this.billingInfo.phoneNumber
      this.member.address = this.billingInfo.address
      if (this.emergencyBool) {
        this.member.emergencyContactInfo = { ...this.billingInfo }
      }

      this.toggle = 3
    },
    async registerMember() {
      this.showLoading = true
      let url = import.meta.env.VITE_APP_DB_URL + 'membership/registerMember'
      swal({
        title: 'Wait for confirmation',
        text: 'Please wait for confirmation',
        icon: 'warning',
        buttons: false,
      })
      let temp = {
        memberFirstName: this.member.firstName,
        memberLastName: this.member.lastName,
        tShirtSize: this.member.tShirtSize,
        membershipID: this.$route.params.id,
        accountLink: import.meta.env.VITE_APP_CLIENT_URL + 'MemberLogin',
      }
      this.billingInfo.paymentPeriodSelected = this.paymentPeriodSelected
      await axios
        .post(url, {
          accountInfo: temp,
          emergencyContactInfo: this.member.emergencyContactInfo,
          customFieldValues: this.member.customFields,
          billingInfo: this.billingInfo,
        })
        .then(() => {
          swal('Success', 'Registration Successful', 'success')
          this.toggle = 4
        })
        .catch(err => {
          console.log(err)
          swal('Error', 'Invalid Card Information', 'error')
          this.toggle = 2
        })
        .finally(() => {
          this.showLoading = false
        })
    },
  },
  computed: {
    isMobile: function () {
      var check = false
      ;(function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a.substr(0, 4),
          )
        )
          check = true
      })(navigator.userAgent || navigator.vendor || window.opera)
      return check
    },
  },
  created() {
    // Fetch search results on page load
    this.getMembershipInfo()
  },
  mounted() {},
}
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid v-bind('membership.secondaryColor || "#f3f3f3"');
  border-top: 5px solid v-bind('membership.primaryColor || "#3498db"');
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
